import { Injectable } from '@angular/core';
import { FaxBackAccount } from '../../../../models/faxback.model';
import { LookupFilterService } from '../../shared/services/lookup-filter.service';
import { DomainTableData, createDomainTableData, initializeColumnVisibility } from '../../shared/types/domain-data.types';
import { FAX_AUDIT_COLUMNS } from '../constants/fax-audit.constants';

@Injectable({
  providedIn: 'root',
})
export class FaxAuditTableService {
  constructor(private readonly filterService: LookupFilterService) {}

  createTableData(
    domainId: string,
    accounts: FaxBackAccount[],
  ): DomainTableData<FaxBackAccount> {
    const columnVisibility = initializeColumnVisibility(FAX_AUDIT_COLUMNS);
    return createDomainTableData(domainId, accounts, columnVisibility);
  }

  applyFilters(tableData: DomainTableData<FaxBackAccount>): void {
    if (!tableData.items.length) {
      tableData.filteredItems = [];
      return;
    }

    tableData.filteredItems = this.filterService.filterItems(
      tableData.items,
      tableData.searchTerm,
      tableData.selectedFilterFields,
      this.createSearchFunction(),
    );
  }

  clearSearch(tableData: DomainTableData<FaxBackAccount>): void {
    tableData.searchTerm = '';
    tableData.selectedFilterFields = ['all'];
    this.applyFilters(tableData);
  }

  getVisibleColumnsCount(tableData: DomainTableData<FaxBackAccount>): number {
    return Object.values(tableData.columnVisibility).filter((visible) => visible)
      .length;
  }

  isColumnVisible(
    tableData: DomainTableData<FaxBackAccount>,
    column: string,
  ): boolean {
    return tableData.columnVisibility[column] ?? true;
  }

  private createSearchFunction(): (
    account: FaxBackAccount,
    term: string,
    field: string,
  ) => boolean {
    return (account: FaxBackAccount, term: string, field: string) => {
      const value =
        account[field as keyof FaxBackAccount]?.toString().toLowerCase() || '';
      return value.includes(term.toLowerCase());
    };
  }
}
